export const environment = {
  production: true,
  apiUrl: 'https://devapi.redcornerai.com/api',
  wsUrl: 'wss://j1lsyxyc4a.execute-api.us-east-2.amazonaws.com/dev',
  stage: 'dev',
  vapidPublicKey: 'BEl62iUYgUivxIkv69yViEuiBIa-Ib9-SkvMeAtA3LFgDzkGs-GDq6QMlP0pJNnJONrDN39_CxP3Fg0XVHSYCTM',
};
